import { NativeModules, Platform } from 'react-native';
import RealtimeKitMeeting from '@cloudflare/realtimekit';
import LocalMediaHandler from './LocalMediaHandler';
import AudioSampleHandler from './AudioSampleHandler';
import BackgroundTimer from './BackgroundHandler';
import { registerGlobals } from '@cloudflare/react-native-webrtc';
import './utils/crypto';
import 'text-encoding-polyfill';
import 'react-native-url-polyfill/auto';
import DeviceInfo from './DeviceInfo';
import { encode, decode } from 'base-64';
global.atob = decode;
global.btoa = encode;

export {
  RealtimeKitProvider,
  useRealtimeKitClient,
  useRTKSelector,
  useRealtimeKitSelector,
  useRealtimeKitMeeting,
} from './ReactHooks';

registerGlobals();

const LINKING_ERROR =
  `The package '@cloudflare/realtimekit-react-native' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are not using Expo managed workflow\n';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Core = NativeModules.Core
  ? NativeModules.Core
  : new Proxy(
      {},
      {
        get() {
          throw new Error(LINKING_ERROR);
        },
      }
    );

declare global {
  // @ts-ignore
  var navigator: any;
}

Object.defineProperty(navigator as any, 'isReactNative', {
  get: function () {
    return true;
  },
  configurable: true,
});

Object.defineProperty(navigator as any, 'userAgent', {
  get: function () {
    return 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4753.0 Safari/537.36'; // customized user agent
  },
  configurable: true,
});

Object.defineProperty(navigator as any, 'RNLocalMediaHandlerImpl', {
  get: function () {
    return LocalMediaHandler;
  },
});

Object.defineProperty(navigator as any, 'RNAudioSampleHandlerImpl', {
  get: function () {
    return AudioSampleHandler;
  },
});

Object.defineProperty(navigator as any, 'RNBackgroundTimerImpl', {
  get: function () {
    return BackgroundTimer;
  },
});

Object.defineProperty(navigator as any, 'RNDeviceInfoImpl', {
  get: function () {
    return DeviceInfo;
  },
});

export default RealtimeKitMeeting;
